export default {
  globalEventDistributor: {},
  navTopMenu: [],
  navLeftMenu: [],
  region: [],
  selectedRegionId: '',
  isShowRegionSelect: true,
  isCreatePage: false,
  userInfo: {},
  accountRemainder: 0,
  messageCount: 0,
  message:[],
  pendingOrder: [],
  isNavCollapsed: true
}
